import request  from './axiosFun';
// 人员列表
 var url = ''
   if (process.env.NODE_ENV === "development") {
     url = '/est'
   }else {
     url = ''
   }
 export function getUserList(query) {
   return request({
     url: url +'/pasture/userInfo/getAllBellowUserListByAreasIdWithPageInfo',
    method: 'post',
    data:query

  })
}
// 删除
export function delAuthUser(query) {

  return request({
    url: url +'pasture/userInfo/delAuthUser',
    method: 'post',
    data:query
  })
}
// 新增
export function addOrUpdate(query) {
  return request({
    url: url  +'/pasture/userInfo/addOrUpdateAuthUser',
    method: 'post',
    data:query
  })
}
// 查询下级区域

export function selectByPCityAreas(query) {

  return request({
    url: url + '/pasture-manage/sysManage/selectByPCityAreas',
    method: 'post',
    data:query,
    platFlag:'notoken'
  })
}
// 查询当前账户的信息

export function getUserAuthInfo(query) {

  return request({
    url: url + '/pasture/userInfo/getUserAuthInfo',
    method: 'post',
    data:query,
  })
}

// 编辑
export function editOrUpdate(query) {
  return request({
    url: url + '/pasture/userInfo/updateAuthUser',
    method: 'post',
    data:query
  })
}
// 查询组织机构列表

export function selectAllDept(query) {
  return request({
    url: url + '/pasture/lsorganization/selectAllDept',
    method: 'post',
    data:query
  })
}
// 新增组织机构

export function addDept(query) {
  return request({
    url: url + '/pasture/lsorganization/addDept',
    method: 'post',
    data:query
  })
}
// 更新组织机构
export function updateDept(query) {
  return request({
    url: url + '/pasture/lsorganization/updateDept',
    method: 'post',
    data:query
  })
}
// 删除组织机构


export function delDept(query) {
  return request({
    url: url + '/pasture/lsorganization/delDept/' + query.id,
    method: 'get'
  })
}

// 新增防疫

export function addOrUpdateAuthUser(query) {
  return request({
    url: url + '/pasture/userInfo/addOrUpdateAuthUser',
    method: 'post',
    data:query
  })
}
// 防疫列表
export function getUserListByDeptId(query) {
  return request({
    url: url + '/pasture/userInfo/getUserListByDeptId',
    method: 'post',
    data:query
  })
}
// 删除防疫人员

export function delAuthUserFY(query) {
  return request({
    url: url + '/pasture/userInfo/delAuthUser',
    method: 'post',
    data:query
  })
}
// 更新防疫人员信息
export function updateAuthUserFY(query) {
  return request({
    url: url + '/pasture/userInfo/updateAuthUser',
    method: 'post',
    data:query
  })
}
// 人员各类型数量

export function getAllBellow(query) {
  return request({
    url: url + '/pasture/userInfo/getAllBellowUserListByAreasIdWithPageInfoForStatistics',
    method: 'post',
    data:query
  })
}
// 下载excel模板

export function downExcelTemp(query) {
  return request({
    url: url + '/pasture/tuserauthinfo/downExcelTemp',
    method: 'get',
    data:query
  })
}
// 导入防疫员模板
export function importExcel(query) {
  return request({
    url: url + '/pasture/tuserauthinfo/importExcelForAuth',
    method: 'post',
    data:query
  })
}

// 人员管理的辖区

export function getDeptList(query) {
  return request({
    url: url + '/pasture/lsorganization/getDeptListByAreaId',
    method: 'post',
    data:query
  })
}



// WEBPACK FOOTER //
// ./src/api/system.js